import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import RadioButton from '../../../../components/form/RadioButton'
import { setTraceUrlYn } from '../campaignSlice'

const TraceUrl = () => {
  const dispatch = useDispatch()
  const { traceUrlYn } = useSelector(state => state.ad.campaign.form)
  const handleChange = useCallback(
    value => dispatch(setTraceUrlYn(value)),
    [dispatch]
  )
  return (
    <div className="area_item">
      <strong className="subtit_box">
        추적URL
        <HelpTooltip>
          광고 랜딩URL에 파라미터로 광고정보를 전달하는 기능을 설정할 수
          있습니다.
        </HelpTooltip>
      </strong>
      <div className="cont_card">
        <div className="item_card">
          <div className="filter_radio">
            <RadioButton
              name="traceUrlYn"
              value="Y"
              label="설정"
              checked={traceUrlYn === 'Y'}
              onValueChange={handleChange}
            />
            <RadioButton
              name="traceUrlYn"
              value="N"
              label="미설정"
              checked={traceUrlYn === 'N'}
              onValueChange={handleChange}
            />
          </div>
        </div>
        <p className="desc_item">
          추적URL 제공 파라미터 및 추적URL의 정상 설정 여부는{' '}
          <a
            href="https://cs.kakao.com/helps?articleId=1073200657&service=186&category=721&device=2720&locale=ko"
            target="_blank"
            rel="noopener noreferrer"
            className="fc_emph">
            가이드
          </a>
          를 참고하세요.
        </p>
      </div>
    </div>
  )
}
export default TraceUrl
